/**
 * Países distintos con participantes inscritos (fuente: Abril27.csv, columna `pais`),
 * normalizados (mayúsculas, tildes, variantes como México/Mexico, typos puntuales).
 * Orden: alfabético por nombre en español.
 */
export const OLIMPIADAS_PARTICIPATING_COUNTRIES = [
  { name: "Angola", code: "AO" },
  { name: "Argentina", code: "AR" },
  { name: "Bolivia", code: "BO" },
  { name: "Brasil", code: "BR" },
  { name: "Chile", code: "CL" },
  { name: "Colombia", code: "CO" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cuba", code: "CU" },
  { name: "Ecuador", code: "EC" },
  { name: "El Salvador", code: "SV" },
  { name: "Eslovaquia", code: "SK" },
  { name: "España", code: "ES" },
  { name: "Estados Unidos", code: "US" },
  { name: "Guatemala", code: "GT" },
  { name: "Honduras", code: "HN" },
  { name: "India", code: "IN" },
  { name: "México", code: "MX" },
  { name: "Nicaragua", code: "NI" },
  { name: "Panamá", code: "PA" },
  { name: "Paraguay", code: "PY" },
  { name: "Perú", code: "PE" },
  { name: "Reino Unido", code: "GB" },
  { name: "República Dominicana", code: "DO" },
  { name: "Uruguay", code: "UY" },
  { name: "Venezuela", code: "VE" },
];
